import type { IntlShape, MessageDescriptor } from 'react-intl';

import { aiExperienceApplicationMessages } from '@atlaskit/editor-common/ai-messages/ai-experience-application';

/**
 * @param messageTemplate The MessageDescriptor that corresponds to the loading status.
 * @returns Defaults to "Generating" if the messageTemplate is unknown or undefined.
 */
export const mapLoadingStatusToMessageTemplate = (
	messageTemplate: string | undefined,
): MessageDescriptor => {
	switch (messageTemplate) {
		case 'ANALYSING_QUERY':
			return aiExperienceApplicationMessages.messageTemplateAnalysingQuery;
		case 'CONTENT_SEARCH':
			return aiExperienceApplicationMessages.messageTemplateContentSearch;
		case 'PAGE_HYDRATION':
			return aiExperienceApplicationMessages.messageTemplatePageHydration;
		case 'NEXT_BEST_TASK':
			return aiExperienceApplicationMessages.messageTemplateNextBestTask;
		case 'WRITING':
			return aiExperienceApplicationMessages.loadingTitle;
		default:
			return aiExperienceApplicationMessages.generatingAiResponse;
	}
};

export const getLoadingMessage = ({
	status,
	formatMessage,
}: {
	formatMessage: IntlShape['formatMessage'];
	status?: string;
}): string => {
	const messageTemplate = mapLoadingStatusToMessageTemplate(status);
	return formatMessage(messageTemplate);
};
